import ModalInfo from 'components/shared/ModalInfo'
import Text from 'components/shared/Text'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import {
    setIsConditionConfirmed,
    setIsConfirmationModalOpen,
} from 'store/general-slice'

const ConfirmationModal = () => {
    const {
        confirmationModal: { isModalOpen, details },
    } = useAppSelector((state) => state.general)
    const dispatch = useAppDispatch()

    const handleCancel = () => {
        dispatch(setIsConfirmationModalOpen(false))
        dispatch(setIsConditionConfirmed(false))
    }

    const handleApprove = () => {
        dispatch(setIsConditionConfirmed(true))
        dispatch(setIsConfirmationModalOpen(false))
    }

    return (
        <ModalInfo
            width={570}
            isOpened={isModalOpen}
            linkLabel={details.buttonDenyText}
            buttonLabel={details.buttonApproveText}
            onButtonClick={handleApprove}
            onLinkClick={handleCancel}
            variant="primary"
            testIdPrefix="age-confirmation-modal"
        >
            <Text variant="heading3">{details.header}</Text>
            <Text
                variant="body"
                mt={16}
                color="grayscale_900"
                dangerouslySetInnerHTML={{ __html: details.description ?? '' }}
            />
        </ModalInfo>
    )
}

export default ConfirmationModal
